import SourceFlowForm from "@sourceflow-uk/sourceflowform";
import SourceFlowApplicationForm from "@sourceflow-uk/sourceflowapplicationform";
import { Helmet } from "react-helmet";
import classes from "./styles.module.scss";
import clsx from "classnames";
import { useLink } from "@/hooks/useLink";

/**
 * Declares the Font Awesome face the form's icons resolve against.
 *
 * The kit stylesheet this replaced reached the icon classes through an `@import`, costing an
 * extra sequential request, and shipped no `font-display` — so the icon could sit in an
 * indefinite invisible period. `block` is used rather than `swap` because these are icon
 * glyphs at private-use codepoints: a fallback font has nothing to put there, so `swap`
 * would flash a placeholder box before the icon appeared.
 */
const FONT_AWESOME_FACE = `
  @font-face {
    font-family: 'FontAwesome';
    src: url('https://use.fontawesome.com/releases/v4.7.0/fonts/fontawesome-webfont.woff2') format('woff2'),
         url('https://use.fontawesome.com/releases/v4.7.0/fonts/fontawesome-webfont.woff') format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: block;
  }
`;

/**
 *
 * @param id
 * @returns {JSX.Element}
 * @constructor
 */
export const Form = ({ className, formId = null, jobId = null, onSubmitDone = null }) => {
  const link = useLink();

  if (formId === null && jobId == null) {
    return null;
  }

  const handleSubmit = () => {
    if (typeof onSubmitDone === "function") {
      return onSubmitDone();
    }

    if (typeof window !== "undefined" && jobId !== null) {
      window.location.href = link("jobs.complete");
    }

    if (typeof window !== "undefined" && formId !== null) {
      window.location.href = link("jobs.form.complete");
    }
  };

  return (
    <div className={clsx(className, classes.form)}>
      <Helmet>
        <link
          rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/choices.js/public/assets/styles/choices.min.css"
          crossOrigin="anonymous"
          referrerPolicy="no-referrer"
        />
        <link
          id="fa"
          rel="stylesheet"
          href="https://use.fontawesome.com/releases/v4.7.0/css/font-awesome-css.min.css"
        />
        <style>{FONT_AWESOME_FACE}</style>
      </Helmet>
      {jobId ? (
        <SourceFlowApplicationForm jobId={jobId} onSubmitDone={handleSubmit} />
      ) : (
        <SourceFlowForm formId={formId} onSubmitDone={handleSubmit} />
      )}
    </div>
  );
};
